import { CssBaseline, ThemeProvider } from '@mui/material'
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3'
import { Route, Routes } from 'react-router-dom'

import ReleasePreview from 'src/components/pages/SmartLink/ReleasePreview'
import SignUpFormModern from 'src/components/pages/SmartLink/SignUp/SignUpFormModern'
import lightTheme from 'src/styles/light.theme'

export type themeSelector = 'dark' | 'light'

const App = () =>
  <GoogleReCaptchaProvider
    reCaptchaKey={process.env.NODE_ENV === 'production'
      ? '6LeyK-0nAAAAAMITr4vAjYkFjvEx_IdiTIYVoky5'
      : '6Ld0d0MrAAAAAJgGEpSspBzrF7YsZ9bq85nLeXPi'}
    useEnterprise
  >
    <ThemeProvider theme={lightTheme}>
      <CssBaseline />
      <Routes>
        <Route
          element={<SignUpFormModern />}
          path='/embed-form/:linkId/:organisationId/:eventItem/:platform'
        />
        <Route element={<ReleasePreview />} path='*' />
      </Routes>
    </ThemeProvider>
  </GoogleReCaptchaProvider>
export default App
